// frontend/src/components/PixDisplay.jsx (VERSÃO COMPLETA E CORRIGIDA)

import React, { useState } from 'react';
import './PixDisplay.css';

const PixDisplay = ({ pixData, onCancel }) => {
  const [copyButtonText, setCopyButtonText] = useState('Copiar Código PIX');

  const handleCopyPixCode = () => {
    if (pixData?.qrCodeText) {
      // Usa a API de Clipboard do navegador, que é mais moderna e segura
      navigator.clipboard.writeText(pixData.qrCodeText).then(() => {
        setCopyButtonText('Copiado com Sucesso!');
        // Reseta o texto do botão após 2.5 segundos para o usuário poder clicar novamente
        setTimeout(() => setCopyButtonText('Copiar Código PIX'), 2500);
      }).catch(err => {
        console.error('Falha ao copiar o código PIX:', err);
        setCopyButtonText('Erro ao Copiar');
        alert("Não foi possível copiar o código. Por favor, copie manualmente.");
      });
    }
  };

  return (
    <div className="pix-modal-overlay">
      <div className="pix-display-content">
        <h3>Pague com PIX para confirmar seu credenciamento</h3>
        <p>Escaneie o QR Code abaixo com o aplicativo do seu banco:</p>
        
        <div className="qr-code-container">
          {pixData.qrCodeImageUrl ? (
            // =================================================================
            // --- A CORREÇÃO PRINCIPAL E ÚNICA ESTÁ AQUI, NA LINHA ABAIXO ---
            // =================================================================
            <img 
              src={`data:image/png;base64,${pixData.qrCodeImageUrl}`} 
              alt="PIX QR Code" 
            />
          ) : (
            <p className="error-text">Erro ao carregar QR Code.</p>
          )}
        </div>

        <div className="pix-copy-paste-section">
          <p>Ou use o PIX Copia e Cola:</p>
          <div className="pix-code-wrapper">
            {pixData.qrCodeText}
          </div>
          <button 
            onClick={handleCopyPixCode} 
            className={`copy-pix-button ${copyButtonText.includes('Copiado') ? 'copied' : ''}`}
          >
            {copyButtonText}
          </button>
        </div>

        <p className="waiting-confirmation">
          Após o pagamento, sua credenciamento será ativado automaticamente. Você pode fechar esta janela e aguardar na página de perfil.
        </p>
        
        <button onClick={onCancel} className="close-pix-button">
          Confirmar Credenciamento
        </button>
      </div>
    </div>
  );
};

export default PixDisplay;